import { combineEpics } from 'redux-observable';

import fetchStayHistoryEpic from './epics/fetchStayHistory';

export default combineEpics(fetchStayHistoryEpic);
